import { atomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type { UnitTypeMismatchesResponse } from './types';

export const [
  unitTypeMismatchesQueryAtom,
  unitTypeMismatchesQueryLoadableAtom,
] = atomWithLoadable(async () => {
  const response = await request.get<UnitTypeMismatchesResponse>(
    '/admin/unit_type_mismatches_query'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});
